import { mapProps } from 'recompose'
import omit from 'ramda/src/omit'

const omitProps = keys => mapProps(props => omit(keys, props))

export default omitProps
